import { ReactNode } from 'react';

export function ProseContent({ children }: { children: ReactNode }) {
  return (
    <article className="prose prose-xl max-w-prose mx-auto prose-h3:font-space prose-h3:tracking-tight prose-h2:font-space prose-h2:tracking-tight">
      {children}
    </article>
  );
}
